import { useState, useCallback } from 'react';
import { pushErrorFromAPI } from 'src/utilities/notifications';
import {
  getEmailAvailability,
  EmailAvailabilityResponse,
} from 'src/common/features/DinersManagement/functions/checkEmailAvailability';

export type checkEmailAvailability = (email: string) => Promise<boolean>;

export type UseCheckEmailAvailabilityReturn = {
  isLoading: boolean;
  checkEmailAvailability: checkEmailAvailability;
};

export const useCheckEmailAvailability = (
  corpId: string
): UseCheckEmailAvailabilityReturn => {
  const [isLoading, setIsLoading] = useState(false);

  const checkEmailAvailability = useCallback(
    async (email) => {
      try {
        setIsLoading(true);
        const responseData: EmailAvailabilityResponse =
          await getEmailAvailability(corpId, email);
        return responseData.available;
      } catch (error) {
        pushErrorFromAPI(error);
        return true;
      } finally {
        setIsLoading(false);
      }
    },
    [corpId]
  );

  return {
    checkEmailAvailability,
    isLoading,
  };
};
